import React, { useState } from 'react';
import './faq.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronRight, faSearch, faQuestionCircle, faBookOpen, faCreditCard, faHeadset } from "@fortawesome/free-solid-svg-icons";
import { Link } from 'react-router-dom';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState({});
  const [searchTerm, setSearchTerm] = useState('');
  const [activeCategory, setActiveCategory] = useState('all');

  const toggle = (key) => {
    setOpenIndex(prev => {
      // Dacă item-ul este deja deschis, îl închidem
      if (prev[key]) {
        return { [key]: false };
      }
      // Altfel, închidem toate și deschidem doar pe acesta
      return { [key]: true };
    });
  };

  const faqData = [
    {
      category: 'platform',
      categoryName: 'Despre platforma',
      icon: faQuestionCircle,
      items: [
        { key: '1-1', q: 'Ce este ContaLearn?', a: 'ContaLearn este o platforma online care te ajuta sa inveti contabilitate pas cu pas, prin lectii interactive, exemple practice si teste de evaluare.' },
        { key: '1-2', q: 'Cui se adreseaza ContaLearn?', a: 'Studentilor la economie, antreprenorilor, angajatilor din domeniul financiar-contabil si oricui vrea sa inteleaga contabilitatea intr-un mod clar si aplicat.' }
      ]
    },
    {
      category: 'courses',
      categoryName: 'Structura cursurilor',
      icon: faBookOpen,
      items: [
        { key: '2-1', q: 'Ce contine un curs?', a: 'Fiecare curs include lectii teoretice, exemple aplicate, exercitii interactive si un test final. La finalul fiecarui curs poti obtine o diploma digitala.' },
        { key: '2-2', q: 'Pot invata in ritmul meu?', a: 'Da. Toate lectiile sunt disponibile oricand. Poti invata in propriul tau ritm, de oriunde, de pe orice dispozitiv.' },
        { key: '2-3', q: 'Trebuie sa parcurg lectiile in ordine?', a: 'Da, recomandam parcurgerea in ordine, pentru ca unele concepte se bazeaza pe cele anterioare. Lectiile se deblocheaza doar dupa ce le-ai finalizat pe cele precedente.' }
      ]
    },
    {
      category: 'progress',
      categoryName: 'Progres si certificare',
      icon: faQuestionCircle,
      items: [
        { key: '3-1', q: 'Primesc diploma la final?', a: 'Da. La finalul fiecarui curs poti descarca o diploma digitala care atesta cunostintele dobandite.' },
        { key: '3-2', q: 'Pot reveni la lectii deja finalizate?', a: 'Da. Ai acces oricand la lectiile parcurse pentru recapitulare sau consolidare.' }
      ]
    },
    {
      category: 'account',
      categoryName: 'Cont si acces',
      icon: faQuestionCircle,
      items: [
        { key: '4-1', q: 'Este gratuita platforma?', a: 'Momentan toate lectiile sunt gratuite. Ai acces complet la toate cursurile si testele din platforma.' },
        { key: '4-2', q: 'Pot folosi ContaLearn pe telefon?', a: 'Da. Platforma este optimizata pentru dispozitive mobile, tableta si desktop.' },
        { key: '4-3', q: 'Ce se intampla daca imi uit parola?', a: 'Poti reseta parola direct din pagina de login, folosind adresa de email asociata contului.' }
      ]
    },


    {
      category: 'support',
      categoryName: 'Asistenta si suport',
      icon: faHeadset,
      items: [
        { key: '6-1', q: 'Am o problema tehnica. Ce pot face?', a: 'Poti trimite un email catre suport@contalearn.ro sau folosi formularul de contact de pe site.' },
        { key: '6-2', q: 'Pot trimite feedback despre o lectie?', a: 'Da. Ne bucuram sa primim feedback. In fiecare lectie exista optiunea de a trimite sugestii sau intrebari.' }
      ]
    }
  ];

  const filteredData = faqData.filter(cat => {
    if (activeCategory !== 'all' && cat.category !== activeCategory) return false;
    if (!searchTerm) return true;
    return cat.items.some(item => 
      item.q.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.a.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }).map(cat => ({
    ...cat,
    items: cat.items.filter(item =>
      item.q.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.a.toLowerCase().includes(searchTerm.toLowerCase())
    )
  })).filter(cat => cat.items.length > 0);

  return (
    <div className="faq-container">
 

      <div className='ajutor-title-top-faq'>


           <div className='tittle-ab-top'>
            <h4>Intrebari frecvente</h4>
        </div>
       

        
        <p className='faq-subtitle'>Gaseste rapid raspunsuri la intrebarile tale</p>
      </div>

      <div className='faq-search-section'>
        <div className='search-box'>
          <FontAwesomeIcon icon={faSearch} className='search-icon' />
          <input
            type='text'
            placeholder='Cauta in intrebari...'
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className='search-input'
          />
        </div>
        
        <div className='category-filters'>
          <button 
            className={`filter-btn ${activeCategory === 'all' ? 'active' : ''}`}
            onClick={() => setActiveCategory('all')}
          >
            Toate
          </button>
          {faqData.map(cat => (
            <button 
              key={cat.category}
              className={`filter-btn ${activeCategory === cat.category ? 'active' : ''}`}
              onClick={() => setActiveCategory(cat.category)}
            >
              <FontAwesomeIcon icon={cat.icon} />
              {cat.categoryName}
            </button>
          ))}
        </div>
      </div>

      {filteredData.length === 0 ? (
        <div className='no-results'>
          <FontAwesomeIcon icon={faQuestionCircle} className='no-results-icon' />
          <h3>Nu am gasit rezultate</h3>
          <p>Incearca sa reformulezi cautarea sau contacteaza-ne direct</p>
        </div>
      ) : (
        filteredData.map((category) => (
          <div className="faq-category" key={category.category}>
            <div className='title-help'>
              <FontAwesomeIcon icon={category.icon} className='category-icon' />
              <h3>{category.categoryName}</h3>
              <span className='item-count'>{category.items.length} intrebari</span>
            </div>
            <div className='line-ajutor'></div>

            {category.items.map((item, index) => (
              <React.Fragment key={item.key}>
                <div className={`faq-item ${openIndex[item.key] ? 'active' : ''}`}>
                  <div className="faq-question" onClick={() => toggle(item.key)}>
                    <span>{item.q}</span>
                    <FontAwesomeIcon icon={faChevronDown} className="icon" />
                  </div>
                  <div className="faq-answer">
                    <p>{item.a}</p>
                  </div>
                </div>
                {index < category.items.length - 1 && <div className='line-ajutor'></div>}
              </React.Fragment>
            ))}
          </div>
        ))
      )}

      <div className='line-ajutor-bot'></div>
      
      <section className='section-cta-aj'>
        <div className='cta-content-faq'>
          <h3>Nu ai gasit raspunsul?</h3>
          <p>Echipa noastra este aici sa te ajute</p>
          <div className='cta-buttons-faq'>
            <Link to='/feedback' className='buton-link-learn-aj'>
              <div className='cta-action-aj primary'>Trimite feedback</div>
            </Link>
            <a href='mailto:suport@contalearn.ro' className='buton-link-learn-aj'>
              <div className='cta-action-aj secondary'>Contact direct</div>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;
